type Chat = {
  id: string;
  respondingAt: number | null;
  lastLoopHeartbeatAt: number | null;
};

export function branchRunChat(
  headChat: Chat | null | undefined,
  commits: readonly { chats?: Chat | null }[]
): Chat | null {
  let runChat = headChat ?? null;
  for (const { chats: chat } of commits) {
    if (
      chat?.respondingAt != null &&
      (runChat?.respondingAt == null ||
        chat.respondingAt > runChat.respondingAt)
    ) {
      runChat = chat;
    }
  }
  return runChat;
}
